/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import classNames from 'classnames';
import _ from 'lodash';
import Utils from './utils';
import StudentChunkProgress from './StudentChunkProgress';
import StudentQuizProgress from './StudentQuizProgress';
import style from './GridSquare.scss';

class GridSquare extends Component {
  renderButton = () => {
    const value = this.props.value;
    const max = this.props.max;
    const buttonText = Utils.getTallyText(value, max, this.props.percent);
    const classes = classNames({
      [style.indicator]: true,
      [style.complete]: this.props.complete,
      [style.incomplete]: value && !this.props.complete,
      [style[this.props.type]]: true,
    });

    return <button className={`button-legacy ${classes}`}>{buttonText}</button>;
  };

  render() {
    let popoverContent;

    if (this.props.type === 'videos') {
      popoverContent = (
        <StudentChunkProgress
          classId={this.props.classId}
          studentId={this.props.studentId}
          lessonId={this.props.lessonId}
        />
      );
    } else if (this.props.type === 'quizzes' && this.props.max > 0) {
      popoverContent = (
        <StudentQuizProgress
          classId={this.props.classId}
          studentId={this.props.studentId}
          lessonId={this.props.lessonId}
        />
      );
    } else {
      popoverContent = this.props.popoverContent;
    }

    const popover = popoverContent ? (
      <Popover
        id={_.uniqueId()}
        className={classNames(this.props.type)}
        arrowOffsetTop="10"
      >
        {popoverContent}
      </Popover>
    ) : null;

    return (
      <div className="indicator-container">
        {popover ? (
          <OverlayTrigger
            trigger="click"
            placement="right"
            rootClose
            container={this}
            overlay={popover}
          >
            {this.renderButton()}
          </OverlayTrigger>
        ) : (
          this.renderButton()
        )}
      </div>
    );
  }
}

export default GridSquare;
